<script>

export default {
  name: "ContactEmail",
  props: {
    email: {
      type: Object,
      default: () => ({})
    },
    emailIndex: {
      type: Number,
      default: 0,
    },
    lastEmailIndex: {
      type: Number,
      default: 0,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    label() {
      return this.emailIndex === 0 ? 'Email' : '';
    },
  },
  methods: {
    setEmailValue(e) {
      this.$set(this.email, 'value', e.target.value)
    },
    removeEmail(emailIndex) {
      this.$emit('removeEmail', emailIndex);
    },
    addEmail() {
      this.$emit('addEmail');
    },
  }

}
</script>

<template>
  <div class="email">
    <div
      v-if="editable"
      class="email__item"
    >
      <label class="email__label">{{ label }}</label>
      <div class="email__body">
        <input
          :value="email.value"
          type="text"
          class="email__input"
          autocomplete="off"
          @input="setEmailValue"
        >
      </div>
      <div
        v-if="emailIndex !== lastEmailIndex"
        class="email__item-action"
        @click.stop="removeEmail"
      >
        <i class="icon-minus email__minus-icon"/>
      </div>
      <div
        v-else
        class="email__item-action"
        @click.stop="addEmail"
      >
        <i class="icon-cross email__add-icon"/>
      </div>
    </div>
    <div
      v-if="!editable && email.value"
      class="email__item"
    >
      <label class="email__label">{{ label }}</label>
      <div class="email__body">
        <div class="email__text">
          {{email.value}}
        </div>
      </div>
    </div>

  </div>

</template>

<style scoped lang="scss">
@import "../../../../../../sass/variables";

.email {

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    column-gap: 12px;
  }

  &__label {
    align-self: flex-start;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    color: $color-denim;
    min-width: 168px;
  }

  &__body {
    flex: 1 1 auto;
    min-height: 32px;
  }

  &__item-action {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid $color-seashell;
    box-sizing: border-box;
    border-radius: 5px;
    min-width: 30px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }

  &__add-icon {
    color: $color-denim;
    transform: rotate(45deg);
  }

  &__minus-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2px;
    color: $color-accent;
  }

  &__input {
    width: 100%;
    height: 30px;
    padding: 10px 30px 10px 7px;
    border: 1px solid $color-seashell;
    border-radius: 5px;
  }

  &__text {
    text-align: right;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactServiceProvider/ContactEmail.vue